"use client";

import Image from "next/image";
import { useEffect, useState } from "react";
import {
  animate,
  AnimationPlaybackControls,
  useMotionValue,
  motion,
} from "framer-motion";
import useMeasure from "react-use-measure";

export const Marquee = ({ stringImages }: { stringImages: string }) => {
  const images = [1, 2, 3, 4, 5, 1, 2, 3, 4, 5].map(
    (i) => `/location/${stringImages}-${i}.webp`
  );

  const FAST_DURATION = 45;
  const SLOW_DURATION = 80;
  const [duration, setDuration] = useState(FAST_DURATION);
  const [mustFinish, setMustFinish] = useState(false);
  const [rerender, setRerender] = useState(false);

  const [ref, { width }] = useMeasure();

  const xTranslation = useMotionValue(0);

  useEffect(() => {
    const finalPosition = -width / 2 - 8;

    let controls: AnimationPlaybackControls | undefined;

    if (mustFinish) {
      controls = animate(xTranslation, [xTranslation.get(), finalPosition], {
        ease: "linear",
        duration: duration * (1 - xTranslation.get() / finalPosition),
        onComplete: () => {
          setMustFinish(false);
          setRerender(!rerender);
        },
      });
    } else {
      controls = animate(xTranslation, [0, finalPosition], {
        ease: "linear",
        duration: duration,
        repeat: Infinity,
        repeatType: "loop",
        repeatDelay: 0,
      });
    }

    return () => {
      controls?.stop();
    };
  }, [xTranslation, width, duration, mustFinish, rerender]);

  return (
    <motion.div
      className="flex gap-3"
      ref={ref}
      style={{
        x: xTranslation,
        width: "max-content",
      }}
      onHoverStart={() => {
        setMustFinish(true);
        setDuration(SLOW_DURATION);
      }}
      onHoverEnd={() => {
        setMustFinish(true);
        setDuration(FAST_DURATION);
      }}
    >
      {images.map((img, idx) => (
        <div
          key={idx}
          className="size-[85px] sm:size-[135px] relative flex-shrink-0 "
        >
          <Image
            src={img}
            alt="image"
            fill
            className="object-cover rounded-[10px]"
          />
        </div>
      ))}
    </motion.div>
  );
};
